<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["exTime"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bmbh"  oninput="if(value.length>5)value=value.slice(0,5)" >
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["cycleType"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.fzr" maxlength="8">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["cycleParam"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.rs" oninput="if(value.length>4)value=value.slice(0,4)">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["tskId"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bmzz" maxlength="120">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["status"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.sjbm" oninput="if(value.length>5)value=value.slice(0,5)">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.tbdz" maxlength="50">
        </div>
    </div>
    
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
export default {
  methods: {
    checkInput(){
       if (!this.checkNull(this.data.bmbh, "nullId")) return false 
       if (!this.checkNull(this.data.bmmc, "nullName")) return false 
       return true
    }
  },
  mixins: [mixin.detail]
}
</script>

